module.exports = __webpack_public_path__ + "img/744.2114633a.jpg";